<button
  appearance="flat"
  class="pointer-events-auto"
  size="s"
  tuiDropdownAppearance="sync-center"
  tuiIconButton
  type="button"
  [tuiDropdown]="dropdown"
  [tuiDropdownManual]="syncCenterState.isOpen()"
  [tuiDropdownMaxHeight]="800"
  (click)="syncCenterState.toggle()">
  <pxc-sync-global-status-icon [size]="Size.SMALL" [status]="globalSyncStatus()" [variant]="'iconOnly'" />
</button>

<ng-template #dropdown>
  <ng-container *transloco="let t">
    <pxc-sync-center
      [items]="items()"
      [title]="t('Mise en ligne des vidéos')"
      (deleteChild)="deleteChild.emit($event)"
      (resumeChild)="resumeChild.emit($event)"
      (retryChild)="retryChild.emit($event)" />
  </ng-container>
</ng-template>
